import { render } from "./Navigation.vue?vue&type=template&id=0dcb2a3d&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=0dcb2a3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dcb2a3d"

export default script